export default function FacilitiesController(
  $q,

  editFacilitiesDialog,
  ssDialogService
) {
  const vm = this;

  vm.handleEditFacilitiesClick = _handleEditFacilitiesClick;

  _activate();

  /** **********************************************
   * Event Handlers
   */

  function _handleEditFacilitiesClick($event) {
    ssDialogService.dialogs.bcp.editFacilitiesDialog = ssDialogService.alert(
      editFacilitiesDialog.getOptions($event, {
        assessmentFacilities: vm.assessmentFacilities,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editFacilitiesDialog);
  }

  /** **********************************************
   * Private Functions
   */

  function _activate() {
  }
}

FacilitiesController.$inject = [
  '$q',

  'editFacilitiesDialog',
  'ssDialogService',
];
